export default "__VITE_ASSET__Bzkg14Nl__"